import { render, staticRenderFns } from "./HomeDirectorList.vue?vue&type=template&id=324ac5a3&scoped=true&"
import script from "./HomeDirectorList.vue?vue&type=script&lang=js&"
export * from "./HomeDirectorList.vue?vue&type=script&lang=js&"
import style0 from "./HomeDirectorList.vue?vue&type=style&index=0&id=324ac5a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ac5a3",
  null
  
)

export default component.exports